import React from 'react';
import { ArrowRight, Wand2 } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import Reveal from './Reveal';
import { useContent } from '../context/ContentContext';
import { useLang } from '../context/LanguageContext';
import { PRODUCT_PATHS } from './ProductPage';

const IndustryFinder = () => {
  const data = useContent('products', null);
  const { t } = useLang();

  if (!data || !(data.items || []).length) return null;

  const scrollToContact = () => {
    const el = document.getElementById('contact');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="py-24 px-6 bg-white" data-testid="industry-finder">
      <div className="max-w-[1080px] mx-auto">
        <Reveal className="text-center mb-12">
          <p className="text-xs font-semibold text-[#0071E3] tracking-widest uppercase mb-4">
            {t('finder.eyebrow')}
          </p>
          <h2 className="text-3xl sm:text-4xl font-semibold text-[#1D1D1F] tracking-tight mb-3">
            {t('finder.title')}
          </h2>
          <p className="text-[#86868B] max-w-2xl mx-auto">{t('finder.subtitle')}</p>
        </Reveal>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-8">
          {data.items.map((item, i) => (
            <Reveal key={item.id} delay={i * 50}>
              <Link
                to={PRODUCT_PATHS[item.id] || '/'}
                className="group flex items-center gap-4 bg-[#F5F5F7] hover:bg-white border border-transparent hover:border-[#E8E8ED] hover:shadow-lg rounded-2xl p-5 transition-all duration-300"
                data-testid={`industry-chip-${item.id}`}
              >
                <span className="w-3 h-3 rounded-full flex-shrink-0" style={{ backgroundColor: item.color }} />
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-semibold text-[#1D1D1F]">{t(`finder.industries.${item.id}`)}</p>
                  <p className="text-xs text-[#86868B] truncate">{item.name}</p>
                </div>
                <ArrowRight
                  className="w-4 h-4 flex-shrink-0 text-[#86868B] group-hover:translate-x-1 transition-transform"
                  style={{ color: item.color }}
                />
              </Link>
            </Reveal>
          ))}
        </div>

        <Reveal>
          <div className="bg-[#1D1D1F] rounded-3xl p-8 md:p-10 flex flex-col md:flex-row items-center gap-6 md:gap-10">
            <div className="w-12 h-12 rounded-2xl bg-white/10 flex items-center justify-center flex-shrink-0">
              <Wand2 className="w-6 h-6 text-[#2997FF]" strokeWidth={1.8} />
            </div>
            <div className="flex-1 text-center md:text-left">
              <h3 className="text-xl font-semibold text-white mb-2">{t('finder.other')}</h3>
              <p className="text-sm text-[#A1A1A6] max-w-xl">{t('finder.otherText')}</p>
            </div>
            <Button
              onClick={scrollToContact}
              className="rounded-full h-12 px-8 bg-[#0071E3] hover:bg-[#0077ED] text-white flex-shrink-0"
              data-testid="industry-other-cta"
            >
              {t('finder.otherCta')}
              <ArrowRight className="ml-2 w-4 h-4" />
            </Button>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default IndustryFinder;
